// Kept beside the module; wired into the application's existing locale resources.
const entries = {
  healthTitle: ['Gjennomføringsfeil', 'Completion issues', 'Genomförandefel'],
  healthNeedsFix: ['Må rettes', 'Needs attention', 'Behöver åtgärdas'],
  healthSummary: ['{{count}} guider har feil som hindrer gjennomføring', '{{count}} guides have errors preventing completion', '{{count}} guider har fel som hindrar genomförande'],
  healthSummaryHint: ['Kontroller berørte brukere. Rett tilgangen eller deaktiver guiden for å frigjøre kravet.', 'Review affected users. Correct access or deactivate the guide to release the requirement.', 'Kontrollera berörda användare. Rätta åtkomsten eller inaktivera guiden för att häva kravet.'],
  healthShow: ['Vis guider med feil', 'Show guides with errors', 'Visa guider med fel'],
  healthBlocked: ['Kan ikke fullføres av {{count}} brukere', 'Cannot be completed by {{count}} users', 'Kan inte slutföras av {{count}} användare'],
  healthDetails: ['Se feil og berørte brukere', 'View errors and affected users', 'Visa fel och berörda användare'],
  healthHelp: ['Kontrollen gjelder den aktive, publiserte revisjonen. Kontroller lesetilgang og godkjenningsstatus i HMS. Ved endret dokument eller bilde må en ny guiderevisjon publiseres. Deaktiver guiden hvis kravet må stoppes mens feilen rettes. Svar og historikk beholdes.', 'This check applies to the active published revision. Check read access and approval status in HSE. A changed document or image requires a new guide revision. Deactivate the guide if its requirement must be suspended during repair. Responses and history are retained.', 'Kontrollen gäller den aktiva publicerade revisionen. Kontrollera läsåtkomst och godkännandestatus i arbetsmiljömodulen. Ett ändrat dokument eller en bild kräver en ny guiderevision. Inaktivera guiden om kravet måste stoppas under åtgärden. Svar och historik bevaras.'],
  healthChecking: ['Kontrollerer tilgang og innhold…', 'Checking access and content…', 'Kontrollerar åtkomst och innehåll…'],
  healthClear: ['Ingen blokkerende innholdsfeil er funnet for nåværende tildelinger.', 'No blocking content issues found for current assignments.', 'Inga blockerande innehållsfel hittades för aktuella tilldelningar.'],
  healthProblem: ['Hva må kontrolleres?', 'What needs checking?', 'Vad behöver kontrolleras?'],
  healthDocument: ['Dokumentversjonen er utilgjengelig eller endret. Kontroller brukerens lesetilgang, HMS-abonnement, godkjenning og dokumentfil.', 'The document revision is unavailable or changed. Check the user’s read access, HSE subscription, approval and document file.', 'Dokumentrevisionen är otillgänglig eller ändrad. Kontrollera användarens läsåtkomst, abonnemang, godkännande och dokumentfil.'],
  healthImage: ['Bildet mangler, er endret eller er ikke klart. Bytt bildet i en ny revisjon.', 'The image is missing, changed or not ready. Replace it in a new revision.', 'Bilden saknas, har ändrats eller är inte klar. Ersätt den i en ny revision.'],
  healthRecheck: ['Kontroller på nytt', 'Check again', 'Kontrollera igen'],
  jsonAudienceInvalid: ["Målgruppen må være alle ansatte eller aktive stillinger i dette firmaet. Bruk gyldige, unike stillings-ID-er fra AI-instruksen.","Audience must be all employees or active positions in this company. Use valid, unique position IDs from the AI instructions.","Målgruppen måste vara alla anställda eller aktiva befattningar i företaget. Använd giltiga, unika befattnings-ID:n från AI-instruktionen."],
  jsonPositionsFailed: ["Kunne ikke hente alle ansattstillinger. Last på nytt før du kopierer AI-instruksen eller importerer målgruppe.","Could not load all employee positions. Reload before copying AI instructions or importing an audience.","Kunde inte hämta alla befattningar. Läs in igen innan du kopierar AI-instruktionen eller importerar målgrupp."],
  jsonPositionsLoading: ["Henter firmaets ansattstillinger …","Loading company employee positions …","Hämtar företagets befattningar …"],
  jsonPositionsIncluded: ["AI-instruksen inneholder {{count}} aktive ansattstillinger med navn og ID.","AI instructions include {{count}} active employee positions with names and IDs.","AI-instruktionen innehåller {{count}} aktiva befattningar med namn och ID."],
  jsonPositionsEmpty: ["Firmaet har ingen aktive ansattstillinger. AI kan bruke alle ansatte eller beholde målgruppen.","This company has no active employee positions. AI can use all employees or preserve the audience.","Företaget har inga aktiva befattningar. AI kan använda alla anställda eller behålla målgruppen."],
  jsonDocumentsLoading: ["Henter firmaets godkjente HMS-dokumenter …","Loading the company's approved HSE documents …","Hämtar företagets godkända arbetsmiljödokument …"],
  jsonDocumentsFailed: ["Kunne ikke hente alle HMS-dokumenter. Last på nytt før du kopierer AI-instruksen eller importerer.","Could not load all HSE documents. Reload before copying the AI instructions or importing.","Kunde inte hämta alla arbetsmiljödokument. Läs in igen innan du kopierar AI-instruktionen eller importerar."],
  jsonDocumentsIncluded: ["AI-instruksen inneholder {{count}} godkjente HMS-dokumenter med nummer, kapittel og versjons-ID.","AI instructions include {{count}} approved HSE documents with number, chapter and version ID.","AI-instruktionen innehåller {{count}} godkända arbetsmiljödokument med nummer, kapitel och versions-ID."],
  jsonDocumentsEmpty: ["Firmaet har ingen godkjente HMS-dokumenter ennå. Godkjenn rutinene før AI lager kurs basert på dem.","The company has no approved HSE documents yet. Approve the routines before AI builds guides on them.","Företaget har inga godkända arbetsmiljödokument ännu. Godkänn rutinerna innan AI skapar guider utifrån dem."],
  jsonIncludeExcerpts: ["Ta med utdrag av innholdet","Include content excerpts","Ta med utdrag av innehållet"],
  jsonIncludeExcerptsHelp: ["Gir AI de første ca. 600 tegnene av hvert dokument, så spørsmålene bygger på rutinene. Lim bare inn i AI-verktøy firmaet har godkjent.","Gives AI roughly the first 600 characters of each document so questions are based on the routines. Only paste into AI tools your company has approved.","Ger AI ungefär de första 600 tecknen av varje dokument så att frågorna bygger på rutinerna. Klistra bara in i AI-verktyg som företaget har godkänt."],
  jsonDocumentUnknown: ["Et dokumentkort peker på en dokumentversjon som ikke er godkjent i dette firmaet. Bruk document_version_id fra AI-instruksen.","A document card points to a document version that is not approved in this company. Use document_version_id from the AI instructions.","Ett dokumentkort pekar på en dokumentversion som inte är godkänd i företaget. Använd document_version_id från AI-instruktionen."],
  documentAccessHint: ["Deltakerne får lesetilgang til dokumentet automatisk. Fullført opplæring registreres som lest og forstått for denne versjonen.","Participants get read access to the document automatically. A completed guide is recorded as read and understood for this version.","Deltagarna får läsåtkomst till dokumentet automatiskt. Genomförd utbildning registreras som läst och förstådd för den här versionen."],
  jsonAudienceChanges: ["Målgruppen erstattes ved import (også ved «Legg til sider»):","Import replaces the audience (also when appending pages):","Importen ersätter målgruppen (även när sidor läggs till):"],
  jsonAudienceUnchanged: ["Målgruppen beholdes; JSON angir ingen endring.","Audience stays unchanged; JSON specifies no change.","Målgruppen behålls; JSON anger ingen ändring."],
  jsonTools: ["JSON / AI", "JSON / AI", "JSON / AI"],
  jsonContent: [
    "Guideinnhold som JSON",
    "Guide content as JSON",
    "Guideinnehåll som JSON",
  ],
  jsonAi: ["AI-instruks", "AI instructions", "AI-instruktion"],
  jsonScope: [
    "Eksporter ulagret innhold eller lim inn JSON med sider, kort og valgfri målgruppe (alle ansatte eller valgte stillinger). Målgruppe endres bare når den er angitt i JSON, også ved Legg til sider. Frister, krav, ansvarlig og e-postvalg beholdes. Lagre og publiser separat.",
    "Export unsaved content or paste JSON with pages, cards and optional audience (all employees or selected positions). Audience changes only when supplied in JSON, including Append pages. Deadlines, requirements, owner and email settings stay unchanged. Save and publish separately.",
    "Exportera osparat innehåll eller klistra in JSON med sidor, kort och valfri målgrupp (alla anställda eller valda befattningar). Målgruppen ändras bara när den anges i JSON, även vid Lägg till sidor. Tidsfrister, krav, ansvarig och e-postval behålls. Spara och publicera separat.",
  ],
  jsonCopy: ["Kopier JSON", "Copy JSON", "Kopiera JSON"],
  jsonReload: [
    "Hent fra redigeringen",
    "Reload from editor",
    "Hämta från redigeraren",
  ],
  jsonExample: ["Sett inn eksempel", "Insert example", "Infoga exempel"],
  jsonImport: [
    "Import til lokal kladd",
    "Import into local draft",
    "Importera till lokalt utkast",
  ],
  jsonReplace: ["Erstatt innhold", "Replace content", "Ersätt innehåll"],
  jsonAppend: ["Legg til sider", "Append pages", "Lägg till sidor"],
  jsonReplaceHint: [
    "Erstatter sider og kort. Navn og beskrivelse oppdateres hvis de er med. Eksisterende ID-er i JSON beholdes.",
    "Replaces pages and cards. Updates title and description when supplied. Existing IDs in the JSON are retained.",
    "Ersätter sidor och kort. Namn och beskrivning uppdateras om de finns med. Befintliga ID:n i JSON behålls.",
  ],
  jsonAppendHint: [
    "Legger sidene etter dagens innhold. Nye ID-er opprettes, og svarvalg og avhengigheter kobles til de nye kortene. Guidens navn og beskrivelse beholdes.",
    "Adds pages after the current content. Generates new IDs and remaps answer choices and dependencies to the new cards. Keeps the guide title and description.",
    "Lägger sidorna efter befintligt innehåll. Nya ID:n skapas och svarsalternativ och beroenden kopplas till de nya korten. Guidens namn och beskrivning behålls.",
  ],
  jsonReview: ["Kontroller import", "Review import", "Granska import"],
  jsonReviewSummary: [
    "{{pages}} sider og {{cards}} kort er klare for gjennomgang.",
    "{{pages}} pages and {{cards}} cards are ready for review.",
    "{{pages}} sidor och {{cards}} kort är redo för granskning.",
  ],
  jsonReferences: [
    "Kontroller innhold og riktige svar før lagring. HMS- og bildereferanser må tilhøre dette firmaet og kontrolleres av serveren ved lagring/publisering. Importen godkjenner ingen gjennomføring.",
    "Check the content and correct answers before saving. HMS document and image references must belong to this company and are checked by the server when saving/publishing. Import does not approve any completion.",
    "Kontrollera innehåll och rätta svar före sparande. HMS- och bildreferenser måste tillhöra företaget och kontrolleras av servern vid sparande/publicering. Importen godkänner ingen genomföring.",
  ],
  jsonApply: [
    "Bruk i lokal kladd",
    "Apply to local draft",
    "Använd i lokalt utkast",
  ],
  jsonApplied: [
    "Innholdet er lagt inn i lokal kladd. Kontroller det før du lagrer og publiserer.",
    "Content applied to the local draft. Review it before saving and publishing.",
    "Innehållet har lagts in i det lokala utkastet. Granska det innan du sparar och publicerar.",
  ],
  jsonReadOnly: [
    "Eksport er tilgjengelig. Opprett en ny revisjon for å importere i en publisert guide.",
    "Export is available. Create a new revision to import into a published guide.",
    "Export är tillgänglig. Skapa en ny revision för att importera till en publicerad guide.",
  ],
  jsonAiHint: [
    "Kopier instruksen til ditt AI-verktøy og beskriv guiden du ønsker. Lim deretter resultatet inn i JSON-fanen. Promang sender ikke innhold til en AI-tjeneste her.",
    "Copy the instructions to your AI tool and describe the guide you want. Then paste the result into the JSON tab. Promang does not send content to an AI service here.",
    "Kopiera instruktionen till ditt AI-verktyg och beskriv guiden du vill ha. Klistra sedan in resultatet på JSON-fliken. Promang skickar inte innehåll till någon AI-tjänst här.",
  ],
  jsonCopyAi: [
    "Kopier AI-instruks",
    "Copy AI instructions",
    "Kopiera AI-instruktion",
  ],
  jsonCopied: [
    "Kopiert til utklippstavlen.",
    "Copied to clipboard.",
    "Kopierat till urklipp.",
  ],
  jsonClipboardFailed: [
    "Kunne ikke kopiere. Marker teksten og kopier manuelt.",
    "Could not copy. Select the text and copy manually.",
    "Kunde inte kopiera. Markera texten och kopiera manuellt.",
  ],
  jsonInvalid: [
    "Ugyldig JSON eller innholdsstruktur. Bruk eksempelet; minst én side og ett kort med tittel eller innhold kreves. Kladden er ikke endret.",
    "Invalid JSON or content structure. Use the example; at least one page and one card with a title or body are required. Your draft is unchanged.",
    "Ogiltig JSON eller innehållsstruktur. Använd exemplet; minst en sida och ett kort med titel eller innehåll krävs. Utkastet är oförändrat.",
  ],
  jsonUnsupported: [
    "JSON inneholder ukjent format, korttype eller felt. Bare innhold og målgruppe beskrevet i AI-instruksen støttes; fjern øvrige innstillinger, godkjenninger og historikk.",
    "The JSON contains an unsupported format, card type or field. Only content and audience described in the AI instructions are supported; remove other settings, approvals and history.",
    "JSON innehåller ett okänt format, en korttyp eller ett fält som inte stöds. Bara innehåll och målgrupp i AI-instruktionen stöds; ta bort övriga inställningar, godkännanden och historik.",
  ],
  jsonSize: [
    "Innholdet er for stort. Maks 50 sider, 200 kort, 20 svarvalg per kort og 200 kB sideinnhold. Kontroller også lengden på tekstfeltene.",
    "Content is too large. Maximum 50 pages, 200 cards, 20 choices per card and 200 kB of page content. Also check text field lengths.",
    "Innehållet är för stort. Högst 50 sidor, 200 kort, 20 svarsalternativ per kort och 200 kB sidinnehåll. Kontrollera även textfältens längd.",
  ],
  jsonIdentity: [
    "ID-er må være unike og bestå av 1–100 bokstaver (a–z), tall, bindestrek eller understrek. Ingen sider eller kort er endret.",
    "IDs must be unique and contain 1–100 ASCII letters, digits, hyphens or underscores. No pages or cards were changed.",
    "ID:n måste vara unika och bestå av 1–100 ASCII-bokstäver, siffror, bindestreck eller understreck. Inga sidor eller kort har ändrats.",
  ],
  jsonAnswers: [
    "Kontroller svarvalgene og fasiten. Spørsmål krever 2–20 navngitte svar og gyldige riktige svar-ID-er. Ettvalg krever nøyaktig ett riktig svar.",
    "Check answer choices and the answer key. Questions require 2–20 named choices and valid correct option IDs. Single choice requires exactly one correct answer.",
    "Kontrollera svarsalternativen och facit. Frågor kräver 2–20 namngivna alternativ och giltiga ID:n för rätta svar. Enkelval kräver exakt ett rätt svar.",
  ],
  jsonDependency: [
    "Et kort viser til en ukjent avhengighet, eller avhengighetene danner en sirkel. Bruk bare kort-ID-er som finnes i JSON-innholdet.",
    "A card references an unknown dependency or the dependencies form a cycle. Use only card IDs present in the JSON content.",
    "Ett kort hänvisar till ett okänt beroende eller beroendena bildar en cirkel. Använd bara kort-ID:n som finns i JSON-innehållet.",
  ],
  jsonReference: [
    "Dokument- og bildereferanser må være positive heltall. Påkrevd dokumentlesing trenger en dokumentversjon, og bilder trenger alternativ tekst.",
    "Document and image references must be positive integers. Required document reading needs a document version, and images need alternative text.",
    "Dokument- och bildreferenser måste vara positiva heltal. Obligatorisk dokumentläsning behöver en dokumentversion och bilder behöver alternativ text.",
  ],
  deliveries: ["Varsellogg", "Notification log", "Aviseringslogg"],
  deliveryPending: ["Venter", "Pending", "Väntar"],
  deliverySending: ["Sender", "Sending", "Skickar"],
  deliverySent: ["Sendt", "Sent", "Skickat"],
  deliveryFailed: ["Feilet", "Failed", "Misslyckat"],
  deliveryUnknown: ["Ukjent resultat", "Unknown outcome", "Okänt resultat"],
  deliveryCancelled: ["Avbrutt", "Cancelled", "Avbrutet"],
  deliveryDigest: [
    "Statusoppsummering",
    "Status summary",
    "Statussammanfattning",
  ],
  recipient: ["Mottaker", "Recipient", "Mottagare"],
  scheduledAt: ["Planlagt", "Scheduled", "Planerat"],
  sentAt: ["Sendt tidspunkt", "Sent at", "Skickat tidpunkt"],
  deliveryPolicy: [
    "E-post sendes bare når det er aktivert for guiden. Loggen viser bekreftet leveringsstatus; den viser ikke at mottakeren har lest e-posten.",
    "Email is sent only when enabled for the guide. The log shows confirmed delivery status; it does not show that the recipient read the email.",
    "E-post skickas bara när det är aktiverat för guiden. Loggen visar bekräftad leveransstatus, inte att mottagaren har läst e-posten.",
  ],
  deliveryNoRetry: [
    "E-posten kan allerede være sendt. Ingen automatisk ny utsending; kontakt Promang for avklaring.",
    "The email may already have been sent. It will not be resent automatically; contact Promang to clarify.",
    "E-posten kan redan ha skickats. Ingen automatisk omsändning; kontakta Promang för utredning.",
  ],
  deliveryFailureHint: [
    "Leveransen kunne ikke bekreftes. Kontakt Promang dersom oppfølging er nødvendig.",
    "Delivery could not be confirmed. Contact Promang if follow-up is needed.",
    "Leveransen kunde inte bekräftas. Kontakta Promang om uppföljning behövs.",
  ],
  dueBefore: ["Frist senest", "Due no later than", "Tidsfrist senast"],
  archive: ["Arkiver guide", "Archive guide", "Arkivera guide"],
  archived: ["Arkivert", "Archived", "Arkiverad"],
  archiveInfo: [
    "Guiden fjernes fra aktiv bruk og kan ikke publiseres igjen. Gjennomføringer og historikk bevares.",
    "The guide is removed from active use and cannot be published again. Completions and history are retained.",
    "Guiden tas bort från aktiv användning och kan inte publiceras igen. Genomföranden och historik bevaras.",
  ],
  title: [
    "Opplæring og etterlevelse",
    "Training and compliance",
    "Utbildning och efterlevnad",
  ],
  intro: [
    "Gi kollegene trygghet i rutinene. Følg opp det som gjenstår.",
    "Help colleagues understand your routines. Follow up on what remains.",
    "Hjälp kollegorna förstå rutinerna. Följ upp det som återstår.",
  ],
  guides: ["Guider", "Guides", "Guider"],
  reports: ["Gjennomføringer", "Completions", "Genomföranden"],
  audit: ["Historikk", "History", "Historik"],
  newGuide: ["Ny guide", "New guide", "Ny guide"],
  edit: ["Rediger kladd", "Edit draft", "Redigera utkast"],
  revise: ["Ny revisjon", "New revision", "Ny revision"],
  copy: ["Kopier som ny guide", "Copy as a new guide", "Kopiera som ny guide"],
  deactivate: ["Deaktiver", "Deactivate", "Inaktivera"],
  reactivate: ["Aktiver igjen", "Reactivate", "Återaktivera"],
  deactivateInfo: [
    "Krav og nye varsler stoppes med det samme. Svar og historikk beholdes.",
    "Requirements and new notifications stop immediately. Responses and history are retained.",
    "Krav och nya aviseringar stoppas direkt. Svar och historik bevaras.",
  ],
  reactivateInfo: [
    "Gjeldende revisjon blir tilgjengelig igjen. Uendrede, beståtte kort beholdes.",
    "The current revision becomes available again. Unchanged passed cards remain completed.",
    "Aktuell revision blir tillgänglig igen. Oförändrade godkända kort behålls.",
  ],
  copyInfo: [
    "Kopien blir en selvstendig kladd. Tidligere gjennomføringer følger ikke med.",
    "The copy becomes an independent draft. Previous completions are not copied.",
    "Kopian blir ett eget utkast. Tidigare genomföranden följer inte med.",
  ],
  saved: ["Kladden er lagret", "Draft saved", "Utkastet har sparats"],
  published: [
    "Guiden er publisert",
    "Guide published",
    "Guiden har publicerats",
  ],
  updated: ["Endringen er lagret", "Change saved", "Ändringen har sparats"],
  saving: ["Lagrer…", "Saving…", "Sparar…"],
  loadError: [
    "Kunne ikke hente oversikten. Prøv å laste på nytt.",
    "Could not load the overview. Try reloading.",
    "Kunde inte hämta översikten. Försök läsa in igen.",
  ],
  reload: ["Last på nytt", "Reload", "Läs in igen"],
  refreshWarning: [
    "Handlingen er utført, men oversikten kunne ikke oppdateres. Last oversikten på nytt.",
    "The action succeeded, but the overview could not be refreshed. Reload the overview.",
    "Åtgärden utfördes, men översikten kunde inte uppdateras. Läs in översikten igen.",
  ],
  unknown: [
    "Resultatet er ikke bekreftet. Kontroller status før du prøver igjen.",
    "The result is not confirmed. Check its status before retrying.",
    "Resultatet är inte bekräftat. Kontrollera status innan du försöker igen.",
  ],
  checkStatus: ["Kontroller status", "Check status", "Kontrollera status"],
  conflict: [
    "Kladden er endret av noen andre. Dine endringer er beholdt. Last serverversjonen for å sammenligne før du erstatter kladden.",
    "Someone else changed this draft. Your changes are retained. Load the server version to compare before replacing the draft.",
    "Någon annan har ändrat utkastet. Dina ändringar finns kvar. Läs in serverversionen för att jämföra innan utkastet ersätts.",
  ],
  loadServer: [
    "Vis serverversjon",
    "Show server version",
    "Visa serverversion",
  ],
  useServer: [
    "Forkast mine endringer og bruk serverversjonen",
    "Discard my changes and use the server version",
    "Kasta mina ändringar och använd serverversionen",
  ],
  serverVersion: ["Serverversjon", "Server version", "Serverversion"],
  unsaved: ["Ulagrede endringer", "Unsaved changes", "Osparade ändringar"],
  discard: ["Forkast endringene", "Discard changes", "Kasta ändringarna"],
  keepEditing: ["Fortsett å redigere", "Keep editing", "Fortsätt redigera"],
  leaveQuestion: [
    "Vil du lukke uten å lagre?",
    "Close without saving?",
    "Stäng utan att spara?",
  ],
  saveDraft: ["Lagre kladd", "Save draft", "Spara utkast"],
  publish: ["Publiser guiden", "Publish guide", "Publicera guiden"],
  publishConfirm: [
    "Publiser til målgruppen",
    "Publish to the audience",
    "Publicera till målgruppen",
  ],
  publishInfo: [
    "Publisert innhold låses. Videre endringer lages som en ny revisjon.",
    "Published content is locked. Further changes are made in a new revision.",
    "Publicerat innehåll låses. Fortsatta ändringar görs i en ny revision.",
  ],
  about: ["Om guiden", "About the guide", "Om guiden"],
  content: ["Innhold", "Content", "Innehåll"],
  audience: [
    "Målgruppe og krav",
    "Audience and requirements",
    "Målgrupp och krav",
  ],
  followup: ["Oppfølging", "Follow-up", "Uppföljning"],
  review: [
    "Forhåndsvis og publiser",
    "Preview and publish",
    "Förhandsvisa och publicera",
  ],
  name: ["Navn", "Name", "Namn"],
  purpose: ["Formål", "Purpose", "Syfte"],
  minutes: [
    "Anslått tidsbruk (minutter)",
    "Estimated duration (minutes)",
    "Uppskattad tid (minuter)",
  ],
  owner: ["Ansvarlig", "Responsible person", "Ansvarig"],
  selectOwner: [
    "Velg ansvarlig",
    "Select a responsible person",
    "Välj ansvarig",
  ],
  revision: ["Revisjon", "Revision", "Revision"],
  changeNote: ["Hva er endret?", "What changed?", "Vad har ändrats?"],
  addPage: ["Legg til side", "Add page", "Lägg till sida"],
  page: ["Side", "Page", "Sida"],
  pageTitle: ["Sidetittel", "Page title", "Sidrubrik"],
  addCard: ["Legg til kort", "Add card", "Lägg till kort"],
  card: ["Kort", "Card", "Kort"],
  cardTitle: ["Overskrift / spørsmål", "Heading / question", "Rubrik / fråga"],
  cardType: ["Korttype", "Card type", "Korttyp"],
  body: [
    "Innhold og veiledning",
    "Content and guidance",
    "Innehåll och vägledning",
  ],
  contentType: ["Tekst og bilde", "Text and image", "Text och bild"],
  acknowledgementType: ["Bekreftelse", "Acknowledgement", "Bekräftelse"],
  singleType: ["Ett riktig svar", "One correct answer", "Ett rätt svar"],
  multipleType: [
    "Flere riktige svar",
    "Multiple correct answers",
    "Flera rätta svar",
  ],
  documentType: ["Dokumentlesing", "Document reading", "Dokumentläsning"],
  required: ["Påkrevd kort", "Required card", "Obligatoriskt kort"],
  options: ["Svaralternativer", "Answer options", "Svarsalternativ"],
  addOption: ["Legg til svar", "Add answer", "Lägg till svar"],
  correct: ["Riktig svar", "Correct answer", "Rätt svar"],
  explanation: [
    "Forklaring etter svar",
    "Explanation after answering",
    "Förklaring efter svar",
  ],
  moveUp: ["Flytt opp", "Move up", "Flytta upp"],
  moveDown: ["Flytt ned", "Move down", "Flytta ned"],
  remove: ["Fjern", "Remove", "Ta bort"],
  dependency: [
    "Spørsmålet bygger på disse kortene",
    "This question depends on these cards",
    "Frågan bygger på dessa kort",
  ],
  imageAlt: [
    "Beskriv bildet for skjermleser",
    "Describe the image for screen readers",
    "Beskriv bilden för skärmläsare",
  ],
  saveBeforeImage: [
    "Lagre kladden før du laster opp bilder.",
    "Save the draft before uploading images.",
    "Spara utkastet innan du laddar upp bilder.",
  ],
  imageReady: ["Bilde lagt til", "Image added", "Bild tillagd"],
  document: ["HMS-dokument", "HSE document", "Arbetsmiljödokument"],
  documentSearch: [
    "Søk etter godkjent HMS-dokument",
    "Search approved HSE documents",
    "Sök godkända arbetsmiljödokument",
  ],
  noDocuments: [
    "Ingen godkjente dokumentversjoner funnet",
    "No approved document versions found",
    "Inga godkända dokumentversioner hittades",
  ],
  boundVersion: [
    "Bundet dokumentversjon",
    "Bound document version",
    "Bunden dokumentversion",
  ],
  readRequired: [
    "Dokumentet må leses og bekreftes",
    "The document must be read and acknowledged",
    "Dokumentet måste läsas och bekräftas",
  ],
  allUsers: [
    "Alle aktive brukere",
    "All active users",
    "Alla aktiva användare",
  ],
  positions: [
    "Valgte stillinger",
    "Selected employee positions",
    "Valda befattningar",
  ],
  namedUsers: ["Valgte brukere", "Selected users", "Valda användare"],
  audienceHint: [
    "Flere stillinger inkluderer brukere i minst én valgt stilling. Brukere uten stilling omfattes av «alle» eller direkte valg.",
    "Selecting several positions includes users in any selected position. Users without a position require everyone or explicit selection.",
    "Flera befattningar inkluderar användare i minst en vald befattning. Användare utan befattning kräver alla eller direkt val.",
  ],
  searchPeople: [
    "Søk brukere eller stillinger",
    "Search users or positions",
    "Sök användare eller befattningar",
  ],
  requirement: [
    "Når skal guiden tas?",
    "When should the guide be completed?",
    "När ska guiden genomföras?",
  ],
  immediate: ["Må tas nå", "Must be completed now", "Måste genomföras nu"],
  deadline: ["Innen frist", "By a deadline", "Inom en tidsfrist"],
  optional: ["Valgfri", "Optional", "Frivillig"],
  newUsersOnly: ["Påkrevd kun for nye ansatte", "Required only for new employees", "Obligatorisk endast för nya anställda"],
  newUsersOnlyHint: [
    "Velg «Må tas nå» eller «Innen frist» for å aktivere. Alle i målgruppen ser kurset. Brukere registrert i firmaet etter at kurset ble opprettet må ta det; for eksisterende brukere er det anbefalt. Nye revisjoner endrer ikke skjæringsdatoen.",
    "Choose Must be completed now or By a deadline to enable. Everyone in the audience sees the course. Users registered in the company after the course was created must complete it; existing users are encouraged to do so. New revisions do not change the cutoff.",
    "Välj Måste genomföras nu eller Inom en tidsfrist för att aktivera. Alla i målgruppen ser kursen. Användare registrerade i företaget efter att kursen skapades måste genomföra den; befintliga användare rekommenderas att göra det. Nya revisioner ändrar inte brytpunkten.",
  ],
  newUsersImmediateWarning: [
    "Guiden sperrer ordinært arbeid kun for brukere i målgruppen som er registrert i firmaet etter at kurset ble opprettet. Eksisterende brukere kan ta den som anbefalt opplæring.",
    "The guide blocks ordinary work only for users in the audience registered in the company after the course was created. Existing users can complete it as recommended training.",
    "Guiden blockerar ordinarie arbete endast för användare i målgruppen registrerade i företaget efter att kursen skapades. Befintliga användare kan genomföra den som rekommenderad utbildning.",
  ],
  deadlineType: [
    "Fristberegning",
    "Deadline calculation",
    "Beräkning av tidsfrist",
  ],
  fixedDate: ["Felles dato", "Fixed date", "Gemensamt datum"],
  relativeDays: [
    "Dager fra tildeling",
    "Days from assignment",
    "Dagar från tilldelning",
  ],
  dueAt: ["Frist", "Due date", "Tidsfrist"],
  dueDays: ["Antall dager", "Number of days", "Antal dagar"],
  mandatorySnooze: ["Tillat Utfør senere – påminn etter 1 time", "Allow Do later – remind after 1 hour", "Tillåt Gör senare – påminn efter 1 timme"],
  mandatorySnoozeHint: [
    "Brukeren kan utsette kurset én time om gangen, også etter fristen, og arbeide i mellomtiden. Kurset er fortsatt påkrevd. Av er standard.",
    "Users can defer the guide one hour at a time, including after its deadline, and work in the meantime. Completion remains required. Off by default.",
    "Användaren kan skjuta upp guiden en timme åt gången, även efter tidsfristen, och arbeta under tiden. Guiden är fortfarande obligatorisk. Av som standard.",
  ],
  snoozeBeforeDeadline: ["Tillat påminnelse senere før fristen", "Allow reminders later before the deadline", "Tillåt senare påminnelse före tidsfristen"],
  snooze: [
    "Tillat påminnelse senere",
    "Allow reminders later",
    "Tillåt senare påminnelse",
  ],
  immediateWarning: [
    "Denne guiden sperrer ordinært arbeid for målgruppen straks den publiseres.",
    "This guide blocks ordinary work for the audience immediately after publication.",
    "Guiden blockerar ordinarie arbete för målgruppen direkt efter publicering.",
  ],
  overdueWarning: [
    "Datoen er passert. Nye brukere får krav om gjennomføring med en gang.",
    "This date has passed. New users will be required to complete the guide immediately.",
    "Datumet har passerat. Nya användare måste genomföra guiden direkt.",
  ],
  emailOptIn: [
    "Send status på e-post til ansvarlig",
    "Email status to the responsible person",
    "Skicka status via e-post till ansvarig",
  ],
  emailHint: [
    "E-post inneholder status og lenke, aldri detaljert fasit eller ansattsvar.",
    "Emails contain status and a link, never detailed answer keys or employee responses.",
    "E-post innehåller status och en länk, aldrig detaljerat facit eller anställdas svar.",
  ],
  cadence: ["Hyppighet", "Frequency", "Frekvens"],
  daily: ["Daglig oppsummering", "Daily summary", "Daglig sammanfattning"],
  weekly: [
    "Ukentlig oppsummering",
    "Weekly summary",
    "Veckovis sammanfattning",
  ],
  events: ["Ved valgte hendelser", "On selected events", "Vid valda händelser"],
  completed: ["Bestått", "Passed", "Godkänd"],
  overdue: ["Forfalt", "Overdue", "Förfallen"],
  blocked: [
    "Dokumenttilgang sperret",
    "Document access blocked",
    "Dokumentåtkomst blockerad",
  ],
  preview: ["Se som bruker", "View as user", "Visa som användare"],
  desktop: ["Desktop", "Desktop", "Dator"],
  mobile: ["Mobil", "Mobile", "Mobil"],
  previewHint: [
    "Forhåndsvisningen registrerer ingen svar, gjennomføringer eller varsler.",
    "Preview does not record responses, completions or notifications.",
    "Förhandsvisning registrerar inga svar, genomföranden eller aviseringar.",
  ],
  impact: [
    "Publiseringskontroll",
    "Publication review",
    "Publiceringskontroll",
  ],
  reviewImpact: [
    "Kontroller målgruppe og endringer",
    "Review audience and changes",
    "Kontrollera målgrupp och ändringar",
  ],
  affectedUsers: ["Berørte brukere", "Affected users", "Berörda användare"],
  withoutPosition: ["Uten stilling", "Without a position", "Utan befattning"],
  changedCards: [
    "Endrede eller nye kort",
    "Changed or new cards",
    "Ändrade eller nya kort",
  ],
  carriedCards: ["Uendrede kort", "Unchanged cards", "Oförändrade kort"],
  removedCards: ["Fjernede kort", "Removed cards", "Borttagna kort"],
  dependencyProblems: [
    "Dokumenttilgang må rettes før publisering",
    "Document access must be corrected before publishing",
    "Dokumentåtkomst måste rättas före publicering",
  ],
  acknowledgeImpact: [
    "Jeg har kontrollert målgruppen, kravene og endringene",
    "I have reviewed the audience, requirements and changes",
    "Jag har kontrollerat målgruppen, kraven och ändringarna",
  ],
  saveForReview: [
    "Lagre endringene før publiseringskontrollen",
    "Save changes before the publication review",
    "Spara ändringarna före publiceringskontrollen",
  ],
  emptyGuides: [
    "Ingen guider her ennå",
    "No guides here yet",
    "Inga guider här ännu",
  ],
  emptyHint: [
    "Begynn med en viktig rutine eller personalhåndboken.",
    "Start with an important routine or the employee handbook.",
    "Börja med en viktig rutin eller personalhandboken.",
  ],
  noResults: [
    "Ingen treff med disse filtrene",
    "No results for these filters",
    "Inga träffar med dessa filter",
  ],
  status: ["Status", "Status", "Status"],
  draft: ["Kladd", "Draft", "Utkast"],
  active: ["Aktiv", "Active", "Aktiv"],
  inactive: ["Deaktivert", "Deactivated", "Inaktiverad"],
  notStarted: ["Ikke startet", "Not started", "Inte påbörjad"],
  inProgress: ["Pågår", "In progress", "Pågår"],
  snoozed: ["Utsatt", "Snoozed", "Uppskjuten"],
  exempt: ["Fritatt", "Exempt", "Undantagen"],
  withdrawn: ["Trukket tilbake", "Withdrawn", "Återkallad"],
  user: ["Bruker", "User", "Användare"],
  guide: ["Guide", "Guide", "Guide"],
  progress: ["Fremdrift", "Progress", "Framsteg"],
  actions: ["Handlinger", "Actions", "Åtgärder"],
  perGuide: ["Per guide", "By guide", "Per guide"],
  perUser: ["Per bruker", "By user", "Per användare"],
  exportCsv: ["Eksporter CSV", "Export CSV", "Exportera CSV"],
  exportPdf: ["Eksporter PDF", "Export PDF", "Exportera PDF"],
  details: ["Se historikk", "View history", "Visa historik"],
  giveExemption: [
    "Gi begrunnet fritak",
    "Grant a reasoned exemption",
    "Ge motiverat undantag",
  ],
  extendDeadline: ["Forleng frist", "Extend deadline", "Förläng tidsfrist"],
  reason: ["Begrunnelse", "Reason", "Motivering"],
  exemptionInfo: [
    "Fritak fjerner kravet, men registreres aldri som bestått. Begrunnelsen lagres i historikken.",
    "An exemption removes the requirement, but is never recorded as passed. The reason is retained in the audit history.",
    "Ett undantag tar bort kravet men registreras aldrig som godkänt. Motiveringen sparas i historiken.",
  ],
  at: ["Tidspunkt", "Time", "Tidpunkt"],
  actor: ["Utført av", "Performed by", "Utförd av"],
  event: ["Hendelse", "Event", "Händelse"],
  attempt: ["Forsøk", "Attempt", "Försök"],
  response: ["Svar", "Response", "Svar"],
  correctResult: ["Riktig", "Correct", "Rätt"],
  incorrectResult: ["Feil", "Incorrect", "Fel"],
  carried: ["Videreført", "Carried forward", "Överfört"],
  previous: ["Forrige", "Previous", "Föregående"],
  next: ["Neste", "Next", "Nästa"],
  cancel: ["Avbryt", "Cancel", "Avbryt"],
  close: ["Lukk", "Close", "Stäng"],
  confirm: ["Bekreft", "Confirm", "Bekräfta"],
  readOnly: [
    "Abonnementet er inaktivt. Du kan fortsatt lese og eksportere historikken.",
    "The subscription is inactive. You can still read and export the history.",
    "Abonnemanget är inaktivt. Du kan fortfarande läsa och exportera historiken.",
  ],
  priceOnRequest: [
    "Pris etter avtale",
    "Price on request",
    "Pris enligt avtal",
  ],
  commercialActivation: [
    "Egen betalingsmodul. Kontakt Promang for avtale og aktivering. Aktivering her gjennomfører ingen betaling.",
    "Separate paid module. Contact Promang for an agreement and activation. Activating here does not collect payment.",
    "Separat betalmodul. Kontakta Promang för avtal och aktivering. Aktivering här genomför ingen betalning.",
  ],
  responsibleReports: [
    "Guider jeg følger opp",
    "Guides I follow up",
    "Guider jag följer upp",
  ],
  receipt: [
    "Gjennomføringskvittering",
    "Completion receipt",
    "Genomförandekvitto",
  ],
  receiptKind: ["Grunnlag", "Basis", "Grund"],
  cardKey: ["Kortreferanse", "Card reference", "Kortreferens"],
  sourceRevision: [
    "Opprinnelig revisjon",
    "Original revision",
    "Ursprunglig revision",
  ],
  acknowledged: [
    "Innhold bekreftet",
    "Content acknowledged",
    "Innehåll bekräftat",
  ],
  createdEvent: ["Guide opprettet", "Guide created", "Guide skapad"],
  savedEvent: ["Kladd lagret", "Draft saved", "Utkast sparat"],
  copiedEvent: ["Guide kopiert", "Guide copied", "Guide kopierad"],
  publishedEvent: [
    "Revisjon publisert",
    "Revision published",
    "Revision publicerad",
  ],
  assignedEvent: ["Guide tildelt", "Guide assigned", "Guide tilldelad"],
  startedEvent: [
    "Gjennomføring startet",
    "Training started",
    "Genomförande påbörjat",
  ],
  answeredEvent: ["Svar kontrollert", "Answer evaluated", "Svar kontrollerat"],
  documentOpenedEvent: ["Dokument åpnet", "Document opened", "Dokument öppnat"],
  completedEvent: [
    "Gjennomføring registrert",
    "Completion recorded",
    "Genomförande registrerat",
  ],
  extendedEvent: ["Frist forlenget", "Deadline extended", "Tidsfrist förlängd"],
  archivedEvent: ["Guide arkivert", "Guide archived", "Guide arkiverad"],
  validationTitle: [
    "Gi guiden et navn",
    "Give the guide a name",
    "Ge guiden ett namn",
  ],
  validationCards: [
    "Legg til minst ett kort",
    "Add at least one card",
    "Lägg till minst ett kort",
  ],
  validationAnswer: [
    "Spørsmål må ha minst to alternativer og gyldig fasit",
    "Questions need at least two options and a valid answer key",
    "Frågor behöver minst två alternativ och ett giltigt facit",
  ],
  validationAudience: [
    "Velg minst én stilling eller bruker",
    "Select at least one position or user",
    "Välj minst en befattning eller användare",
  ],
  validationDocument: [
    "Velg en godkjent dokumentversjon",
    "Select an approved document version",
    "Välj en godkänd dokumentversion",
  ],
  validationImage: [
    "Legg til alternativ tekst for bildet",
    "Add alternative text for the image",
    "Lägg till alternativ text för bilden",
  ],
  validationReason: [
    "Skriv en begrunnelse",
    "Enter a reason",
    "Ange en motivering",
  ],
};
export const trainingAdminTranslations = Object.fromEntries(
  ["no", "en", "sv", "nn"].map((locale, index) => [
    locale,
    Object.fromEntries(
      Object.entries(entries).map(([key, values]) => [
        `trainingAdmin.${key}`,
        values[index === 3 ? 0 : index],
      ]),
    ),
  ]),
);
export default trainingAdminTranslations;
